import { TroubleshootingStepName } from './../constants/index';
import { AngularServices } from './../../core/helpers/get-angular-service';
import { RootScopeEvents } from './../../../common/services/root-scope-types';
import { getAngularService } from '../../core';
import { autoCloseTroubleshootingOnSessionEnd, setStepName } from './index';
export const openTroubleshooting = () => (dispatch) => {
    const $rootScope = getAngularService(AngularServices.RootScope);
    dispatch(setStepName(TroubleshootingStepName.Initial));
    dispatch(autoCloseTroubleshootingOnSessionEnd());
    $rootScope.$emit(RootScopeEvents.USER_ACTIONS.OPEN_TROUBLESHOOTING);
};
